import { CalendarDaysIcon, X } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function CalendarSetupCard({
  onConnect,
  onDismiss,
}: {
  onConnect: () => void
  onDismiss: () => void
}) {
  const { t } = useTranslation()
  return (
    <div className="mb-3 flex items-start gap-3 rounded-xl border border-border bg-card px-4 py-3.5">
      <CalendarDaysIcon
        className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground/60"
        strokeWidth={1.5}
      />
      <div className="min-w-0 flex-1 flex flex-col items-start gap-2">
        <p className="text-sm text-foreground/80">{t('today.calendarSetupPrompt')}</p>
        <button
          type="button"
          onClick={onConnect}
          className="flex shrink-0 cursor-pointer items-center gap-1.5 rounded-full bg-primary/10 px-3 py-1 text-xs font-medium text-primary-text hover:bg-primary/20 transition-colors"
        >
          {t('today.calendarSetupConnect')}
        </button>
      </div>
      <button
        type="button"
        onClick={onDismiss}
        className="mt-0.5 flex h-5 w-5 shrink-0 cursor-pointer items-center justify-center rounded text-muted-foreground/40 transition-colors hover:text-muted-foreground"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  )
}
